import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

type Input = {
  id: number | undefined;
};

const getZapQuery = gql`
  query ZapPreviewQuery($id: ID!) {
    zapV2(id: $id) {
      id
      isInstant
      isPaused
      isShared
      isTrashed
      nodes {
        id
        selectedApi
      }
      owner {
        email
        id
        imageUrl
        name
      }
      shareVisibility
      sourceUrl
      state
      title
    }
  }
`;

function useZap({ id }: Input) {
  const { data, loading } = useQuery(getZapQuery, {
    skip: !id,
    variables: {
      id,
    },
  });

  return {
    isLoading: loading,
    zap: data?.zapV2,
  };
}

export default useZap;
